import type { User, UserAvatar } from '@/modules/auth/types';
import type { Media } from '../Media';

export type InjuryType = {
  id: number;
  name: string;
};

export type BodyRegion = {
  id: number;
  name: string;
};

export type BodySide = {
  id: number;
  name: string;
};

export type SeverityLevel = {
  value: number;
  label: string;
};

export type InjuryData = {
  injury_types: InjuryType[];
  body_regions: BodyRegion[];
  body_sides: BodySide[];
  severity_levels: SeverityLevel[];
};

export type InjuryNote = {
  id: number;
  injury_id: number;
  user_id: number;
  title: string;
  description: string;
  date_of_note: string; // ISO date string
};

export type InjuryNoteWithPhotos = {
  id: number;
  injury_id: number;
  user_id: number;
  title: string;
  description: string;
  date_of_note: string;
  photos: Media[];
  create_by: User;
};

export type InjuryTask = {
  id: number;
  injury_id: number;
  title: string;
  description: string | null;
  completed_at: string | null; // ISO date string or null
  created_at: string;
  updated_at: string;
  added_by: string;
  repeat_label: string | null;
  repeat_type: string | null;
  start_date: string | null;
  current_period_start: string | null;
  current_period_end: string | null;
  current_period_completed: boolean;
  injury?: InjuryResponse;
  history?: InjuryTaskHistory[];
};

export type InjuryTaskHistory = {
  id: number;
  period_end_date: string;
  period_start_date: string;
  status: string;
};

export type InjuryResponse = {
  id: number;
  player_id: number;
  health_professional_id: number;
  name: string;
  description: string;
  body_region: string;
  injury_type: string;
  body_side: string;
  severity: number;
  status: number;
  status_label: string;
  severity_name: string; // e.g., "MAJOR_INJURY"
  injured_at: string; // ISO date
  recovered_at: string | null; // ISO date or null
  created_at: string;
  updated_at: string;
  photos: UserAvatar[]; // adjust type if photos are objects
  notes: InjuryNote[];
  tasks: InjuryTask[];
  player: User;
  healthProfessional: User;
};

export enum InjurySeverity {
  All = 'all',
  NotInjured = 'not injured',
  Minor = 'minor injury',
  Major = 'major injury',
}
